import { useContext } from 'react';
import { FormContext } from '~/components/forms/FormContext';

const PoweredBy = ({ className }) => {
    const { form } = useContext(FormContext);

    const isFree = form?.business?.plan === 'free';

    return (
        <div
            className={`text-center ${isFree ? 'flex flex-col items-center ' : ''} text-sm text-gray-500 ${className}`}
        >
            Powered by{' '}
            <a
                href="https://www.breely.com/?utm_source=poweredby"
                target="_blank"
                className="text-center !text-gray-500"
            >
                {isFree && (
                    <img
                        src="https://www.breely.com/img/logos/logo-email.png"
                        className="w-[100px]"
                        alt="Breely"
                    />
                )}
                {!isFree && 'Breely'}
            </a>
        </div>
    );
};

export default PoweredBy;
